import { BrowserRouter } from 'react-router-dom';
import { AppRoutes } from './router';
import WhatsAppWidget from './components/feature/WhatsAppWidget';

function App() {
  return (
    <BrowserRouter basename={__BASE_PATH__}>
      <AppRoutes />
      <WhatsAppWidget />
    </BrowserRouter>
  );
}

export default App;
